'use strict';

var buildEnhancedMapping = require('../internal/buildEnhancedMapping');

module.exports = buildEnhancedMapping('map');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/var/enhancedMap.js
// module id = 630
// module chunks = 0